<template>
    <div class="jcsz">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="绘本级别" name="1" v-if="dlsglId === 'null'">
          <el-button type="primary" size="small" @click="hbjbAdd()" icon="el-icon-plus">新增</el-button>
          <el-table :data="hbjbList" style="width: 100%;margin: 20px 0;" border>
            <el-table-column type="index" label="序号" width="70"></el-table-column>
            <el-table-column label="级别名称">
              <template slot-scope="scope">
                <span v-if="scope.row.editType"><el-input v-model="scope.row.jbmc"></el-input></span>
                <span v-else>{{scope.row.jbmc}}</span>
              </template>
            </el-table-column>
            <el-table-column label="业务">
              <template slot-scope="scope">
                <span v-if="scope.row.editType">
                  <el-select v-model="scope.row.ywcode" placeholder="请选择业务" filterable>
                    <el-option v-for="item in ywList" :key="item.ywcode" :label="item.ywmc" :value="item.ywcode"></el-option>
                  </el-select>
                </span>
                <span v-else>{{scope.row.ywmc}}</span>
              </template>
            </el-table-column>
            <el-table-column label="顺序" >
              <template slot-scope="scope">
                <span v-if="scope.row.editType"><el-input v-model="scope.row.zhi"></el-input></span>
                <span v-else>{{scope.row.zhi}}</span>
              </template>
            </el-table-column>
            <el-table-column label="合格单词分数" >
              <template slot-scope="scope">
                <span v-if="scope.row.editType"><el-input v-model="scope.row.hgdcfs"></el-input></span>
                <span v-else>{{scope.row.hgdcfs}}</span>
              </template>
            </el-table-column>
            <el-table-column label="正确单词分数" >
              <template slot-scope="scope">
                <span v-if="scope.row.editType"><el-input v-model="scope.row.zqdcfs"></el-input></span>
                <span v-else>{{scope.row.zqdcfs}}</span>
              </template>
            </el-table-column>
            <el-table-column label="最近修改人">
              <template slot-scope="scope">
                <span v-if="scope.row.gxrmc">{{scope.row.gxrmc}}</span>
                <span v-if="!scope.row.gxrmc">{{scope.row.cjrmc}}</span>
              </template>
            </el-table-column>
            <el-table-column label="最近修改时间">
              <template slot-scope="scope">
                <span v-if="scope.row.gxsj">{{formatDate(new Date(scope.row.gxsj),'yyyy-MM-dd hh:mm:ss')}}</span>
                <span v-if="scope.row.cjsj&&!scope.row.gxsj">{{formatDate(new Date(scope.row.cjsj),'yyyy-MM-dd hh:mm:ss')}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <el-button v-if="!scope.row.editType" type="text" size="small" @click="hbjbEdit(scope.$index)">修改</el-button>
                <el-button v-if="scope.row.editType" type="text" size="small" @click="hbjbSave(scope.row)">保存</el-button>
                <el-button v-if="!scope.row.editType" type="text" size="small" @click="hbjbDel(scope.row.id)">删除</el-button>
                <el-button v-if="scope.row.editType&&!scope.row.id" type="text" size="small" @click="hbjbRemove(scope.$index)">移除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="代理商级别" name="2" v-if="dlsglId === 'null'">
          <el-button type="primary" size="small" @click="dlsjbAdd()" icon="el-icon-plus">新增</el-button>
          <el-table :data="dlsjbList" style="width: 100%;margin: 20px 0;" border>
            <el-table-column type="index" label="序号" width="70"></el-table-column>
            <el-table-column label="代理商级别">
              <template slot-scope="scope">
                <span v-if="scope.row.editType"><el-input v-model="scope.row.jbmc"></el-input></span>
                <span v-else>{{scope.row.jbmc}}</span>
              </template>
            </el-table-column>
            <el-table-column label="最近修改人">
              <template slot-scope="scope">
                <span v-if="scope.row.gxrmc">{{scope.row.gxrmc}}</span>
                <span v-if="!scope.row.gxrmc">{{scope.row.cjrmc}}</span>
              </template>
            </el-table-column>
            <el-table-column label="最近修改时间">
              <template slot-scope="scope">
                <span v-if="scope.row.gxsj">{{formatDate(new Date(scope.row.gxsj),'yyyy-MM-dd hh:mm:ss')}}</span>
                <span v-if="scope.row.cjsj&&!scope.row.gxsj">{{formatDate(new Date(scope.row.cjsj),'yyyy-MM-dd hh:mm:ss')}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button v-if="!scope.row.editType" type="text" size="small" @click="dlsjbEdit(scope.$index)">修改</el-button>
                <el-button v-if="scope.row.editType" type="text" size="small" @click="dlsjbSave(scope.row)">保存</el-button>
                <el-button v-if="!scope.row.editType" type="text" size="small" @click="dlsjbDel(scope.row.id)">删除</el-button>
                <el-button v-if="scope.row.editType&&!scope.row.id" type="text" size="small" @click="dlsjbRemove(scope.$index)">移除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
				<el-tab-pane label="机构类型" name="3" v-if="dlsglId != 'null'">
				  <el-button type="primary" size="small" @click="jglxAdd()" icon="el-icon-plus">新增</el-button>
				  <el-table :data="jglxList" style="width: 100%;margin: 20px 0;" border>
				    <el-table-column type="index" label="序号" width="70"></el-table-column>
				    <el-table-column label="机构类型">
				      <template slot-scope="scope">
				        <span v-if="scope.row.editType"><el-input v-model="scope.row.lxmc"></el-input></span>
				        <span v-else>{{scope.row.lxmc}}</span>
				      </template>
				    </el-table-column>
				    <el-table-column label="开通app每个学生每天所需积分" prop="sxjf">
							<template slot-scope="scope">
							  <span v-if="scope.row.editType"><el-input v-model="scope.row.sxjf" min="0" type="number"></el-input></span>
							  <span v-else>{{scope.row.sxjf}}</span>
							</template>
						</el-table-column>
            <el-table-column label="最近修改人">
              <template slot-scope="scope">
                <span v-if="scope.row.gxrmc">{{scope.row.gxrmc}}</span>
                <span v-if="!scope.row.gxrmc">{{scope.row.cjrmc}}</span>
              </template>
            </el-table-column>
            <el-table-column label="最近修改时间">
              <template slot-scope="scope">
                <span v-if="scope.row.gxsj">{{formatDate(new Date(scope.row.gxsj),'yyyy-MM-dd hh:mm:ss')}}</span>
                <span v-if="scope.row.cjsj&&!scope.row.gxsj">{{formatDate(new Date(scope.row.cjsj),'yyyy-MM-dd hh:mm:ss')}}</span>
              </template>
            </el-table-column>
				    <el-table-column label="操作" width="200">
				      <template slot-scope="scope">
				        <el-button v-if="!scope.row.editType" type="text" size="small" @click="jglxEdit(scope.$index)">修改</el-button>
				        <el-button v-if="scope.row.editType" type="text" size="small" @click="jglxSave(scope.row)">保存</el-button>
				        <el-button v-if="!scope.row.editType" type="text" size="small" @click="jglxDel(scope.row.id)">删除</el-button>
				        <el-button v-if="scope.row.editType&&!scope.row.id" type="text" size="small" @click="jglxRemove(scope.$index)">移除</el-button>
				      </template>
				    </el-table-column>
				  </el-table>
				</el-tab-pane>
      </el-tabs>
    </div>
</template>

<script>
import Vue from "vue";
export default {
  name: 'Jcsz',
  data() {
      return {
        activeName: '1',
        hbjbList: [],
        dlsjbList: [],
        ywList: [],
				dlsglId: sessionStorage.getItem("dlsglId"), // 代理商id
				jglxList: []
      }
  },
  mounted() {
		if(this.dlsglId != 'null'){
			this.activeName = '3'
		}
		this.handleClick();
    this.findYwList();
  },
  methods: {
    // 获取业务列表
    findYwList(){
      this.$post("admin/YwController/list", {zt: '1'}).then(rep =>{
        if(rep.code == '1'){
          this.ywList = rep.result.list;
        }
      })
    },
    // tab切换
    handleClick() {
      if (this.activeName == '1') {
        this.findHbjbList();//绘本级别列表
      } else if (this.activeName == '2') {
        this.findDlsjbList();//代理商级别列表
      } else if (this.activeName == '3') {
        this.findJglxList();//机构类型
      }
    },
    //绘本级别列表
    findHbjbList(){
      var _this = this;
      _this.$post("admin/ShezhiController/hbjbList").then(rep =>{
        _this.hbjbList = rep.result.list;
      })
    },
    // 新增绘本级别
    hbjbAdd() {
      var obj = {
        id: '',
        ywcode: '',
        jbmc: '',
        zhi: '',
        hgdcfs: '',
        zqdcfs: '',
        editType: true
      }
      this.hbjbList.push(obj);
    },
    hbjbEdit(index){
      Vue.set(this.hbjbList[index],"editType",true);
    },
    // 新增/编辑保存绘本级别
    hbjbSave(row) {
      if(!row.ywcode){
        this.$message({
          type: "error",
          message: "请选择业务"
        });
        return;
      }
      if(!row.jbmc){
        this.$message({
          type: "error",
          message: "请填写绘本级别名称"
        });
        return;
      }
      if(!row.zhi){
        this.$message({
          type: "error",
          message: "请填写绘本级别顺序"
        });
        return;
      }
      if(!row.hgdcfs){
        this.$message({
          type: "error",
          message: "请填写合格单词分数"
        });
        return;
      }
      if(!row.zqdcfs){
        this.$message({
          type: "error",
          message: "请填写正确单词分数"
        });
        return;
      }
      var obj = {
        id: row.id,
        ywcode: row.ywcode,
        jbmc: row.jbmc,
        zhi: row.zhi,
        hgdcfs: row.hgdcfs,
        zqdcfs: row.zqdcfs
      }
      this.$post("admin/ShezhiController/hbjbSave",obj,'json').then(rep =>{
        if(rep.code == '1'){
          this.$message({
            type: "success",
            message: '保存成功'
          });
          this.findHbjbList();
        }else{
          this.$message({
            type: "error",
            message: rep.msg
          });
        }
      })
    },
    //移除绘本级别
    hbjbRemove(index){
      this.hbjbList.splice(index,1);
    },
    // 删除绘本级别
    hbjbDel(id) {
      this.$confirm('是否确认删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post("admin/ShezhiController/hbjbDel",{id:id}).then(rep =>{
          if(rep.code == '1'){
            this.$message.success('删除成功');
            this.findHbjbList();
          }else{
            this.$message({
              type: "error",
              message: rep.msg
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },


    //代理商级别列表
    findDlsjbList() {
      var _this = this;
      _this.$post("admin/ShezhiController/dlsjbList").then(rep =>{
        _this.dlsjbList = rep.result.list;
      })
    },
    // 新增代理商级别
    dlsjbAdd() {
      var obj = {
        id: '',
        jbmc: '',
        editType: true
      }
      this.dlsjbList.push(obj);
    },
    dlsjbEdit(index){
      Vue.set(this.dlsjbList[index],"editType",true);
    },
    // 新增/编辑保存代理商级别
    dlsjbSave(row) {
      if(!row.jbmc){
        this.$message({
          type: "error",
          message: "请填写代理商级别名称"
        });
        return;
      }
      var obj = {
        id: row.id,
        jbmc: row.jbmc
      }
      this.$post("admin/ShezhiController/dlsjbSave",obj,'json').then(rep =>{
        if(rep.code == '1'){
          this.$message({
            type: "success",
            message: '保存成功'
          });
          this.findDlsjbList();
        }else{
          this.$message({
            type: "error",
            message: rep.msg
          });
        }
      })
    },
    //移除代理商级别
    dlsjbRemove(index){
      this.dlsjbList.splice(index,1);
    },
    // 删除代理商级别
    dlsjbDel(id) {
      this.$confirm('是否确认删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post("admin/ShezhiController/dlsjbDel",{id:id}).then(rep =>{
          if(rep.code == '1'){
            this.$message.success('删除成功');
            this.findDlsjbList();
          }else{
            this.$message({
              type: "error",
              message: rep.msg
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
		findJglxList(){
			var _this = this;
			_this.$post("jggl/JgglController/jglxList",{dlsglId: this.dlsglId}).then(rep =>{
			  _this.jglxList = rep.result.list;
			})
		},
		jglxAdd(){
			var obj = {
			  id: '',
			  jglxmc: '',
			  editType: true
			}
			this.jglxList.push(obj);
		},
		jglxEdit(index){
			Vue.set(this.jglxList[index],"editType",true);
		},
		jglxSave(row){
			if(!row.lxmc){
			  this.$message({
			    type: "error",
			    message: "请填写机构类型"
			  });
			  return;
			}
			if(!row.sxjf){
			  this.$message({
			    type: "error",
			    message: "请填写开通app每个学生每天所需积分"
			  });
			  return;
			}
      if (row.sxjf < 0) {  // 最终保障校验
        this.$message({ type: "error", message: "积分值不能为负数" });
        return;
      }
			var obj = {
			  id: row.id,
			  lxmc: row.lxmc,	
			  sxjf: parseInt(row.sxjf),
				dlsglId: this.dlsglId
			}
			this.$post("jggl/JgglController/jglxSave",obj,'json').then(rep =>{
			  if(rep.code == '1'){
			    this.$message({
			      type: "success",
			      message: '保存成功'
			    });
			    this.findJglxList();
			  }else{
			    this.$message({
			      type: "error",
			      message: rep.msg
			    });
			  }
			})
		},
		jglxDel(id){
			this.$confirm('是否确认删除', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
			}).then(() => {
			  this.$post("jggl/JgglController/jglxDel",{id:id}).then(rep =>{
			    if(rep.code == '1'){
			      this.$message.success('删除成功');
			      this.findJglxList();
			    }else{
			      this.$message({
			        type: "error",
			        message: rep.msg
			      });
			    }
			  })
			}).catch(() => {
			  this.$message({
			    type: 'info',
			    message: '已取消'
			  });
			});
		},
		jglxRemove(index){
			this.jglxList.splice(index,1);
		},
  }
}
</script>

<style lang="less" scoped>
.jcsz {
    table {
        width: 100%;
        border: 1px solid #D7D9D9;
        margin-bottom: 200px;
        thead {
            td {
                background-color: #E9ECF1;
            }
        }

        td {
            height: 50px;
            text-align: center;
        }

        .spks {
            height: 50px;
            display: flex;
            justify-content: space-between;
            .label{
                display: inline-block;
                width: 60px;
                text-align: right;
                margin-right: 15px;
            }

            div {
                line-height: 40px;
            }
        }
    }
}
</style>